module.exports = __webpack_public_path__ + "static/media/sa.612f8ee7.webp";